(function ($, Drupal, once) {
  Drupal.behaviors.iconCardsReadMore = {
    attach: function attach(context, settings) {
      once('iconCardsReadMore', '.icon-card-toggle-content', context).forEach(function(element) {
        $(element).on('click', function() {
          const $button = $(this);
          const $content = $button.siblings('.icon-card-content-wrapper');
          const isExpanded = $button.attr('aria-expanded') === 'true';
          
          // Toggle states
          $button.attr('aria-expanded', !isExpanded);
          $content.attr('aria-hidden', isExpanded);
          
          // Update only the text node before the visually-hidden span
          const $buttonText = $button.find('.icon-card-button-text');
          const $visibleText = $buttonText.contents().first();
          $visibleText[0].textContent = isExpanded ? 'Read more ' : 'Read less ';
          
          // Optional: animate the content
          $content.slideToggle();
        });
      });
    }
  };
})(jQuery, Drupal, once);